// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React from 'react';
import { Button, ButtonRow } from '@op/opds.opux';
import { Modal } from '@op/opds.opux-modal';
import message from '../messages';
import { handleWindowBeforeUnload, invalidateSession } from '../Session';
import { returnLink } from '../Constants';

interface LeaveEServiceModalWindowProps {
    modalOpened: boolean;
    setModalOpened: any;
    modalWindowText: string;
}

const updateModalState = (state: { open: boolean }, setModalOpened: any) => {
    if (!state.open) {
        setModalOpened(false);
    }
};

const LeaveEServiceModalWindow: React.FC<LeaveEServiceModalWindowProps> = ({
    modalOpened,
    setModalOpened,
    modalWindowText,
}) => {
    return (
        <Modal
            isOpen={modalOpened}
            className="interruption-modal"
            onUpdate={(state) => updateModalState(state, setModalOpened)}
            footer={
                <div className="modal-footer">
                    <ButtonRow>
                        <Button onClick={() => setModalOpened(false)} data-testid="leaveEServiceModalCancelButton">
                            {message('no')}
                        </Button>
                        <Button
                            primary
                            data-testid="leaveEServiceModalConfirmButton"
                            onClick={() => {
                                window.removeEventListener('beforeunload', handleWindowBeforeUnload);
                                invalidateSession();
                                window.location.href = returnLink;
                            }}
                        >
                            {message('yes')}
                        </Button>
                    </ButtonRow>
                </div>
            }
        >
            {modalWindowText}
        </Modal>
    );
};

export default LeaveEServiceModalWindow;
